module.exports = __webpack_public_path__ + "img/iphone7.7635b885.jpg";